import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'met-image-fullscreen-viewer',
  templateUrl: './image-fullscreen-viewer.component.html',
  styleUrls: ['./image-fullscreen-viewer.component.scss']
})
export class ImageFullscreenViewerComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public imageURL: string, private dialogRef: MatDialogRef<ImageFullscreenViewerComponent >) { }

  closeViewer(): void {
    this.dialogRef.close();
  }
}
